import { useState } from "react";
import LoginView from "../components/LoginView";
import UploadView from "../components/UploadView";

const MainPage = () => {
  const [step, setStep] = useState(1);
  const [username, setUsername] = useState("");
  const [apiKey, setApiKey] = useState("");

  const onLoginSuccess = (username, apiKey) => {
    setUsername(username);
    setApiKey(apiKey);
    setStep(2);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      {step === 1 && <LoginView onLogin={onLoginSuccess} />}
      {step === 2 && <UploadView user={{ username, apiKey }} />}
    </div>
  );
};

export default MainPage;
